import React from 'react';
import { View } from 'react-native';
import DataTable from '@preflighttech/preflight-tables';
import styled from 'styled-components/native';
import moment from 'moment';

import { Text } from 'app/src/styles';
import { plural } from 'app/src/utils/stringHelpers';

const Counts = styled(View)`
  flex-direction: row;
  gap: 40px;
  margin-bottom: 20px;
`;

const Count = styled(Text)`
  font-weight: bold;
`;

const columns = [
  {
    key: 'startAt',
    label: 'Start Visit',
    content: ({ value }) => moment(value).format('MM-DD-YY \@ hh:mmA')
  },
  {
    key: 'endAt',
    label: 'End Visit',
    content: ({ value }) => (
      value ?  moment(value).format('hh:mmA') : 'Active'
    )
  },
  {
    key: 'buyerUser',
    label: 'Buyer',
    value: ({ value }) => value?.fullName || 'Guest'
  },
  {
    key: 'paddleNumber',
    label: 'Paddle #',
    value: ({ entry }) => entry.buyerUser?.paddleNumber
  },
  {
    key: 'audioStartAt',
    label: 'Audio Active?',
    value: ({ value }) => value ? 'Yes' : ''
  },
];

const Active = ({ activeBidders }) => {
  const approved = activeBidders.filter(visit => (
    'Approved' === visit.buyerUser?.buyer?.status
  ));

  const notApproved = activeBidders.filter(
    visit => visit.buyerUser && 'Approved' !== visit.buyerUser.buyer.status
  );

  const guests = activeBidders.filter(visit => !visit.buyerUser);

  return (
    <View>
      <Counts>
        <Count>{plural(approved.length, 'Approved Buyer')}</Count>
        <Count>
          {plural(notApproved.length, 'Buyer')} Not Approved for Bidding
        </Count>
        <Count>{plural(guests.length, 'Guest')}</Count>
      </Counts>

      <DataTable.Simple
        data={activeBidders}
        columns={columns}
        pageLength="All"
        htmlTable
        sortOnArrowClickOnly
      />
    </View>
  );
};

export default Active;
